import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home';
import ThankYou from './views/ThankYou.vue';
import PriceDisclosure from './views/PriceDisclosure.vue';
import NotFound from './views/NotFound.vue';
import ServerError from './views/ServerError.vue';
import Resources from './views/Resources.vue';
import AllDayEfficacy from './views/AllDayEfficacy.vue';
import SmoothPK from './views/SmoothPK.vue';
import DoseDependentDuration from './views/DoseDependentDuration.vue';
import Dosing from './views/Dosing.vue';
import Safety from './views/Safety.vue';
import Savings from './views/Savings.vue';
import SignUp from './views/SignUp.vue';
import Sitemap from './views/Sitemap.vue';

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior: function (to, from, savedPosition) {
        if (to.hash) {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve({
                        selector: to.hash,
                        behavior: 'smooth',
                        offset: { x: 0, y: -30 },
                    });
                }, 500);
            });
        } else {
            return { x: 0, y: 0 };
        }
    },
    routes: [
        {
            path: '/pi',
            beforeEnter: () => {
                window.location =
                    'https://www.collegiumpharma.com/wp-content/uploads/JORNAY_PM_Label.pdf';
            },
        },
        {
            path: '/season',
            beforeEnter: () => {
                window.location =
                    '/?utm_source=leave-behind&utm_medium=print&utm_campaign=report-card&utm_content=print_report-card&utm_target=hcp';
            },
        },
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: {
                nav: '',
                canonical: '',
            },
        },
        {
            path: '/isi-option-1',
            name: 'isi-option-1',
            component: Home,
            meta: {
                nav: '',
                canonical: 'https://www.jornaypm-pro.com/',
                isiOption: '1',
            },
        },
        {
            path: '/isi-option-2',
            name: 'isi-option-2',
            component: Home,
            meta: {
                nav: '',
                canonical: 'https://www.jornaypm-pro.com/',
                isiOption: '2',
            },
        },
        {
            path: '/isi-option-3',
            name: 'isi-option-3',
            component: Home,
            meta: {
                nav: '',
                canonical: 'https://www.jornaypm-pro.com/',
                isiOption: '3',
            },
        },
        {
            path: '/isi-preview',
            name: 'isi-preview',
            component: Home,
            meta: {
                nav: '',
                canonical: 'https://www.jornaypm-pro.com/',
                isiOption: '1',
            },
        },
        {
            path: '/404',
            name: 'not-found',
            component: NotFound,
        },
        {
            path: '*',
            redirect: '/404',
        },
        {
            path: '/thank-you',
            name: 'thank-you',
            component: ThankYou,
        },
        // {
        //     path: '/videos',
        //     redirect: '/peerspectives',
        // },
        // {
        //     path: '/Price_Disclosure',
        //     name: 'PriceDisclosure',
        //     component: PriceDisclosure,
        // },
        {
            path: '/server-error',
            name: 'server-error',
            component: ServerError,
        },
        {
            path: '/resources',
            name: 'resources',
            component: Resources,
            meta: {
                nav: 'savings',
                canonical: 'https://www.jornaypm-pro.com/resources',
            },
        },
        // {
        //     path: '/peerspectives',
        //     name: 'Peerspectives',
        //     component: Peerspectives,
        //     meta: {
        //         nav: 'savings',
        //         canonical: 'https://www.jornaypm-pro.com/peerspectives',
        //     },
        // },
        // {
        //     path: '/qr/peerspectives',
        //     redirect: '/peerspectives',
        // },
        {
            path: '/adhd-medication-efficacy',
            name: 'adhd-medication-efficacy',
            component: AllDayEfficacy,
            meta: {
                nav: 'about',
                canonical: 'https://www.jornaypm-pro.com/adhd-medication-efficacy',
            },
        },
        {
            path: '/pk-data',
            name: 'pk-data',
            component: SmoothPK,
            meta: {
                nav: 'about',
                canonical: 'https://www.jornaypm-pro.com/pk-data',
            },
        },
        {
            path: '/methylphenidate-dosage-duration',
            name: 'methylphenidate-dosage-duration',
            component: DoseDependentDuration,
            meta: {
                nav: 'about',
                canonical: 'https://www.jornaypm-pro.com/methylphenidate-dosage-duration',
            },
        },
        {
            path: '/dosing',
            name: 'dosing',
            component: Dosing,
            meta: {
                nav: 'dosing',
                canonical: 'https://www.jornaypm-pro.com/dosing',
            },
        },
        {
            path: '/safety',
            name: 'safety',
            component: Safety,
            meta: {
                nav: 'safety',
                canonical: 'https://www.jornaypm-pro.com/safety',
            },
        },
        {
            path: '/savings',
            name: 'savings',
            component: Savings,
            meta: {
                nav: 'savings',
                canonical: 'https://www.jornaypm-pro.com/savings',
            },
        },
        {
            path: '/sign-up',
            name: 'sign-up',
            component: SignUp,
            meta: {
                nav: 'sign-up',
                canonical: 'https://www.jornaypm-pro.com/sign-up',
            },
        },
        {
            path: '/site-map',
            name: 'site-map',
            component: Sitemap,
        },
    ],
});
